module.exports = __webpack_public_path__ + "img/rocket.19165911.svg";